export var productTileOverlayProductTileAdaptor = function(productTile, includeContainer) {
    var _productTile_product;
    return {
        state: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.state,
        includeContainer: includeContainer
    };
};
